var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 5.2502L3.29281 1.73313C3.00003 1.41732 3.04692 1.18664 3.3922 0.986926C4.04127 0.611482 4.54692 0.601285 5.2311 0.97675L8.6644 2.8609C8.90881 2.99503 9.1485 3.13099 9.4001 3.20516",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3501 8.16462L9.8273 12.9291C9.94794 13.3182 10.1603 13.3887 10.4893 13.2001C11.1079 12.8455 11.3572 12.4359 11.3739 11.6978L11.4577 7.99425C11.4689 7.49956 11.4669 7.01543 11.8501 6.65039",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42992 6.28897L6.75075 5.32388L9.84459 3.06822L9.84777 3.06591L9.85576 3.06007C9.94025 2.99827 11.0202 2.21205 11.6343 1.94305C12.3936 1.61045 13.1008 1.76507 13.8618 1.97759C14.2553 2.08751 14.4521 2.14246 14.5941 2.245C14.8194 2.40768 14.9659 2.65808 14.996 2.93194C15.015 3.10455 14.9649 3.3002 14.8646 3.69149C14.6706 4.448 14.4527 5.12971 13.7811 5.61224C13.2379 6.00256 12.0076 6.53245 11.9115 6.57362L11.9025 6.57748L11.8988 6.57904L8.37219 8.0951L6.86477 8.74128L6.86476 8.74129C6.31819 8.97558 6.0449 9.09273 5.85898 9.31012C5.42353 9.81925 5.36204 10.7406 5.19952 11.3745C5.1097 11.7249 4.61723 12.3319 4.17841 12.2408C3.90749 12.1845 3.90229 11.8454 3.86857 11.6291L3.54394 9.5472C3.46631 9.04931 3.46035 9.03913 3.06219 8.72384L1.3973 7.40546C1.22437 7.26852 0.929321 7.09451 1.0154 6.83486C1.15483 6.41429 1.93386 6.29698 2.28623 6.39539C2.92384 6.57346 3.76323 6.9816 4.42779 6.86405C4.71154 6.81386 4.951 6.6389 5.42991 6.28897L5.42992 6.28897Z",
    stroke: "#101513",
    strokeOpacity: 0.8,
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneIcon);
export default __webpack_public_path__ + "static/media/airplane-icon.88cf0ddeea3179f91523c3e1201f301d.svg";
export { ForwardRef as ReactComponent };